import React from "react";
import { Tab, Tabs } from "@mui/material";

interface SettingsTabsProps {
  value: string;
  tabs: { value: string; label: string }[];
  onChange: (value: string) => void;
}

export const SettingsTabs: React.FC<SettingsTabsProps> = ({
  value,
  tabs,
  onChange,
}) => (
  <Tabs
    value={value}
    onChange={(_event, nextValue) => onChange(nextValue)}
    textColor="primary"
    indicatorColor="primary"
    variant="scrollable"
    scrollButtons="auto"
    allowScrollButtonsMobile
    sx={{
      borderBottom: "1px solid",
      borderColor: "divider",
      "& .MuiTabs-scrollButtons": {
        "&.Mui-disabled": { opacity: 0.3 },
      },
    }}
  >
    {tabs.map((tab) => (
      <Tab
        key={tab.value}
        value={tab.value}
        label={tab.label}
        sx={{ textTransform: "none", fontWeight: 600 }}
      />
    ))}
  </Tabs>
);
